var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.618,
    height: 38.9667,
    rx: 19.4833,
    fill: "#FFFDF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0513 23.7L28.3513 12.4C28.6179 12.1333 28.9291 12 29.2846 12C29.6402 12 29.9513 12.1333 30.2179 12.4C30.4846 12.6667 30.618 12.9836 30.618 13.3507C30.618 13.7178 30.4846 14.0342 30.2179 14.3L17.9846 26.5667C17.7179 26.8333 17.4068 26.9667 17.0513 26.9667C16.6957 26.9667 16.3846 26.8333 16.1179 26.5667L10.3846 20.8333C10.1179 20.5667 9.98995 20.2502 10.0006 19.884C10.0113 19.5178 10.1504 19.2009 10.4179 18.9333C10.6855 18.6658 11.0024 18.5324 11.3686 18.5333C11.7348 18.5342 12.0513 18.6676 12.3179 18.9333L17.0513 23.7Z",
    fill: "#AD4D34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.c30fa146b2dacb0d1bbf24d3e6789a1a.svg";
export { ForwardRef as ReactComponent };